import { i18N } from "../../../helper";
class CONSTANTS {
    static template() {
        return `<div class="input__section -schedule">
			<div class="input__divider">
				<span class="input__divider__label">${i18N().scheduled}</span>
				<div class="input__divider__line"></div>
			</div>
			<div class="input__group" data-state="schedule">
				<div class="input__controlgroup -date">
					<span class="input__control__prepend">${acp_woocommerce_i18n.woocommerce.schedule_from}</span>
					<input type="text" name="schedule_from">
				</div>
				<div class="input__controlgroup -date">
					<span class="input__control__prepend">${acp_woocommerce_i18n.woocommerce.schedule_to}</span>
					<input type="text" name="schedule_to">
				</div>
				<div class="input__switch">
					<a class="input__switch__link" data-schedule="Schedule" data-cancel="Cancel">${i18N().schedule}</a>
				</div>
			</div>
			
		</div>`;
    }
}
export default class ScheduleSection {
    constructor() {
        this.state = false;
        this.setElement();
        this.attachEvents();
        this.initState();
    }
    initState() {
        let link = this.getElement().querySelector('.input__switch__link');
        if (this.state) {
            this.toggleDateFields(true);
            link.innerHTML = link.dataset.cancel;
        }
        else {
            this.toggleDateFields(false);
            link.innerHTML = link.dataset.schedule;
        }
    }
    toggleDateFields(display = true) {
        let elements = this.getElement().querySelectorAll('.input__controlgroup.-date');
        for (let i = 0; i < elements.length; i++) {
            elements[i].style.display = display ? 'flex' : 'none';
        }
    }
    attachEvents() {
        this.dateEvents();
        let link = this.getElement().querySelector('.input__switch__link');
        link.addEventListener('click', () => {
            this.state = !this.state;
            this.initState();
        });
    }
    setElement() {
        let element = document.createElement('div');
        element.innerHTML = CONSTANTS.template();
        this.el = element.querySelector('.input__section');
        return this;
    }
    setState(enable = true) {
        this.state = enable;
        return this;
    }
    setFromDate(date) {
        this.getElement().querySelector('[name=schedule_from]').value = date;
    }
    setToDate(date) {
        this.getElement().querySelector('[name=schedule_to]').value = date;
    }
    dateEvents() {
        let dates = jQuery(this.getElement()).find('[name=schedule_from], [name=schedule_to]');
        document.body.classList.add('ac-jqui');
        dates.datepicker({
            dateFormat: 'yy-mm-dd',
            changeYear: true,
            onSelect: function (selectedDate) {
                let option = jQuery(this).is('[name="schedule_from"]') ? 'minDate' : 'maxDate';
                let instance = jQuery(this).data('datepicker');
                let date = jQuery.datepicker.parseDate(instance.settings.dateFormat || jQuery.datepicker._defaults.dateFormat, selectedDate, instance.settings);
                dates.not(jQuery(this)).datepicker('option', option, date);
            }
        });
    }
    getValue() {
        return {
            active: this.state,
            from: this.getElement().querySelector('[name=schedule_from]').value,
            to: this.getElement().querySelector('[name=schedule_to]').value
        };
    }
    show() {
        this.getElement().style.display = 'block';
    }
    hide() {
        this.getElement().style.display = 'none';
    }
    getElement() {
        return this.el;
    }
}
